class OpenTimes {
    constructor(options){
        if(options){
            this.client = options.client
            this.organizationID = options.organizationID
        }
    }
    // mark ***
    fetch(options){
        return this.client.get(`/organizations/${options.organizationID}/openTimes`)
    }
}

export default OpenTimes


// WEBPACK FOOTER //
// ./lib/apiClient/organizations/openTimes.js